import gql from 'graphql-tag';

export const GET_LOCATION_ENVIRONMENT_QUERY = gql`
   query LocationEnvironmentQuery(
    $id: ID!
  ) {
    locationEnvironment(id: $id) {
      id
      name
      qrCode
      description
      archived
      createdAt
      locationSector {
        id
        name
        location {
          id
          name
          address {
            formattedAddress
          }
        }
      }
    }
  }
`;

export const SEARCH_LOCATION_ENVIRONMENTS_QUERY = gql`
  query LocationEnvironmentsQuery (
    $where: LocationEnvironmentWhereInput
    $orderBy: LocationEnvironmentOrderByInput
    $limit: Int
    $offset: Int
  ) {
    locationEnvironments (where: $where, orderBy: $orderBy, limit: $limit, offset: $offset) {
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
      totalCount
      items {
        id
        name
        description
        archived
        locationSector {
          id
          name
          location {
            id
            name
          }
        }
      }
    }
  }
`;

export const CREATE_LOCATION_ENVIRONMENT_MUTATION = gql`
  mutation CreateLocationEnvironment($input: CreateLocationEnvironmentInput!) {
    createLocationEnvironment (input: $input) {
      id
      locationSector {
        id
      }
    }
  }
`;

export const UPDATE_LOCATION_ENVIRONMENT_MUTATION = gql`
  mutation UpdateLocationEnvironment($input: UpdateLocationEnvironmentInput!) {
    updateLocationEnvironment (input: $input) {
      id
      locationSector {
        id
      }
    }
  }
`;
